/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Utils
import Pickr from '@simonwep/pickr';

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';

// Constants
const MAX_SWATCHES = 16;
const COLORPICKER_STORAGE_KEY = 'colorpicker.palette';
const DEFAULT_COLORS = ['#394047', '#AAB3BB', '#FFFFFF', '#3185FC', '#2DD269', '#FFCC00', '#FF9500', '#F25A2A'];
const DEFAULT_OPTIONS = {
    default: DEFAULT_COLORS[0],
    lockOpacity: true,
    position: 'bottom-start',
    swatches: DEFAULT_COLORS,
    theme: 'monolith',
    components: {
        // Main components
        hue: true,

        // Input / output Options
        interaction: {
            save: false,
            cancel: true
        }
    }
};

/**
 * This component is used to allow the user to pick a color
 */
const __vue_script__ = {
    name: 'ColorPicker',

    extends: BaseControl,

    props: {
        context: {
            type: String,
            default: 'spotme'
        },

        value: {
            type: String,
            default: null
        }
    },

    data() {
        return {
            initialized: false,
            innerValue: (this.value || '').toLocaleUpperCase(),
            picker: null,
            previousValue: null,
            cancelled: false,
            debug: false,
            lastEmittedValue: null
        };
    },

    computed: {
        // Pass-through attributes
        /** @returns {object} */
        attrs() {

            /* eslint-disable no-unused-vars */
            const {
                label,
                hint,
                focused,
                ...attrs
            } = Object.assign(this.$options.propsData, this.$attrs);
            /* eslint-enable no-unused-vars */

            return attrs;
        }
    },

    watch: {
        value() {
            this.innerValue = (this.value || '').toLocaleUpperCase();
            this.picker.setColor(this.value);
        },

        disabled(value) {
            if (!this.picker) return;

            if (value) {
                this.picker.disable();
            } else {
                this.picker.enable();
            }
        }
    },

    created() {
        DEFAULT_OPTIONS.i18n = {
            'btn:save': this.$i18n.t('general.confirm').toString(),
            'btn:cancel': this.$i18n.t('general.cancel').toString()
        };
    },

    mounted() {
        const options = Object.assign(DEFAULT_OPTIONS, { el: this.$refs.picker }, this.attrs);
        this.picker = new Pickr(options);

        const PALETTE_KEY = `${COLORPICKER_STORAGE_KEY}-${this.context}`;

        this.picker.on('init', () => {
            this.picker.setColor(this.value);
            this.initialized = true;
            this.debug && console.debug('[ColorPicker] Init', this.value); // Initialization done - pickr can be used

            if (!this.disabled) {
                this.picker.enable();
            } else {
                this.picker.disable();
            }

        }).on('show', (color, instance) => {
            this.cancelled = false;
            this.debug && console.debug('[ColorPicker] `show` event triggered', color, instance); // Pickr got opened
            this.previousValue = instance
                .getColor()
                .toHEXA()
                .toString();

            const palette = this.$services.storage.get(PALETTE_KEY) || [];

            // Cleanup the swatches
            for (let i = instance._swatchColors.length - 1; i >= MAX_SWATCHES; --i) {
                instance.removeSwatch(i);
            }

            // (Re)create new swatches
            const swatches = instance._swatchColors.map(swatch => swatch.color.toHEXA().toString());

            for (const color of palette) {
                if (!swatches.includes(color)) {
                    instance.addSwatch(color);
                }
            }

        }).on('save', color => {
            this.debug && console.debug('[ColorPicker] `save` event triggered', color); // User clicked the save / clear button. Also fired on clear with null as color.

            if (!this.initialized || !color) {
                return;
            }

            const c = color.toHEXA().toString();
            this.emit(c);

            const palette = this.$services.storage.get(PALETTE_KEY) || [];

            if (!palette.includes(c) && !DEFAULT_COLORS.includes(c)) {
                if (palette.length === MAX_SWATCHES) {
                    palette.pop();
                    palette.unshift(c);
                } else {
                    palette.push(c);
                }
            }

            this.previousValue = c;
            this.$services.storage.set(PALETTE_KEY, palette);

            if (this.picker.isOpen()) {
                this.picker.hide();
            }

        }).on('change', color => {
            if (!this.initialized) {
                return;
            }

            const c = color.toHEXA().toString();
            this.debug && console.debug('[ColorPicker] `change` event triggered', c); // Color has changed (but not saved). Also fired on swatchselect
            this.innerValue = c;
            this.picker.applyColor(true);

        }).on('cancel', () => {
            this.debug && console.debug('[ColorPicker] `cancel` event triggered'); // User clicked the cancel button (return to previous color).
            if (this.previousValue) {
                this.picker.setColor(this.previousValue);
            }

            this.cancelled = true;
            this.picker.hide();

        }).on('hide', () => {
            this.debug && console.debug('[ColorPicker] `hide` event triggered'); // Pickr got closed
            if (!this.cancelled) {
                // Force saving
                const c = this.picker.getColor().toHEXA().toString();
                this.picker.setColor(c);
            }

        });
    },

    beforeDestroy() {
        if (this.picker) {
            this.picker.destroyAndRemove();
        }
    },

    methods: {
        emit(value) {
            if (value !== this.lastEmittedValue) {
                this.lastEmittedValue = value;
                this.$emit('input', value?.trim());
            }
        },

        /**
         * Updates the picker when the user enters a valid hex code.
         *
         * @param {InputEvent} event the input event
         */
        updatePicker(event) {
            if (!this.picker.setColor(event.target.value)) {
                // Relaunch for validation
                this.emit(event.target.value);
            }
        }
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "control-decorator",
    {
      staticClass: "color-picker",
      attrs: {
        label: _vm.label,
        tip: _vm.tip,
        hint: _vm.hint,
        errors: _vm.errors,
        uid: _vm.uid,
        "hint-after-label": true,
        warning: _vm.warning,
        dependant: _vm.dependant,
      },
      scopedSlots: _vm._u(
        [
          {
            key: "inside-label",
            fn: function (ref) {
              return [_vm._t("inside-label")]
            },
          },
        ],
        null,
        true
      ),
    },
    [
      _c("div", { ref: "picker", staticClass: "picker" }),
      _c(
        "input",
        _vm._b(
          {
            ref: "input",
            staticClass: "form-control",
            class: {
              "has-error": _vm.errors.length,
              "has-warning": _vm.warning,
            },
            attrs: {
              id: _vm.uid,
              name: _vm.name,
              type: "text",
              disabled: _vm.disabled,
              autocomplete: _vm.autocomplete,
              placeholder: _vm.placeholder,
            },
            domProps: { value: _vm.innerValue },
            on: {
              blur: _vm.updatePicker,
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                ) {
                  return null
                }
                return _vm.updatePicker.apply(null, arguments)
              },
            },
          },
          "input",
          _vm.$attrs,
          false
        )
      ),
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/form-components/pickers/ColorPicker.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__